import { Modal } from "antd";
import ModalContent from '../components/ModalContent';

export default class DialogUtils {

  /**
   * 
   * @param content 
   * @param onOk 
   * @param onCancel 
   */
  static confirm(content: any, onOk?: () => void, onCancel?: () => void, _okText?: string, _cancelText?: string) {
    Modal.confirm({
      title: null,
      icon: null,
      centered: true,
      className: 'success-modal',
      okButtonProps: {
        shape: 'round',
        id: 'modal-success-btn'
      },
      cancelButtonProps: {
        shape: 'round',
        id: 'modal-cancel-btn'
      },
      content: <ModalContent type={'confirm'} content={content} />,
      onOk: () => { if (onOk) onOk(); },
      onCancel: () => { if (onCancel) onCancel(); },
    });
  }


  /**
   * 
   * @param content 
   * @param onOk 
   */
  static error(content: any, onOk?: () => void) {
    Modal.error({
      title: null,
      icon: null,
      centered: true,
      className: 'error-modal',
      okButtonProps: {
        shape: 'round',
        id: 'modal-error-btn'
      },
      content: <ModalContent type={'error'} content={content} />,
      onOk: () => { if (onOk) onOk(); }
    });
  }


  /**
   * 
   * @param content 
   * @param onOk 
   */
  static success(content: any, onOk?: () => void) {
    Modal.success({
      title: null,
      icon: null,
      centered: true,
      className: 'success-modal',
      okButtonProps: {
        shape: 'round',
        id: 'modal-success-btn'
      },
      content: <ModalContent type={'success'} content={content} />,
      onOk: () => { if (onOk) onOk(); }
    });
  }
}